import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AddAuthInterceptor, AddTpiInterceptor } from './services/interceptors';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { Amplify } from 'aws-amplify';
import { environment } from '../environments/environment';


// // Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolClientId: environment.cognito.userPoolClientId,
      userPoolId: environment.cognito.userPoolId,
    }
  }
});


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideAnimationsAsync(), 
    provideHttpClient(withInterceptors([AddAuthInterceptor, AddTpiInterceptor])),
    provideCharts(withDefaultRegisterables())
  ]
};


